import React from "react";
import classNames from "classnames";
import { CellProps } from "react-table";
import { AssignedTicket } from "../types";

export default function BulkTicketStatusCell(props: CellProps<AssignedTicket>) {
  const classname = React.useMemo(
    () => props.row.original.ticketStatus.toLowerCase(),
    [props.row.original.ticketStatus]
  );
  return (
    <div className={classNames("bulkTicket_status", `bulkTicket_status--${classname}`)}>
      <span>{props.value}</span>
    </div>
  );
}
